const WEB3FORMS_KEY = "73f72609-2ee3-47fc-8881-af5f57401ee3";

export function initContactForm() {
  const form = document.querySelector("[data-contact-form]");
  const notice = document.querySelector("[data-form-notice]");
  if (!form || !notice) return;

  const submitBtn = form.querySelector('button[type="submit"]');
  const params = new URLSearchParams(window.location.search);
  const interest = params.get("interest");
  const select = form.querySelector("#interest");
  if (interest && select) {
    const match = Array.from(select.options).find((option) => option.value === interest);
    if (match) select.value = interest;
  }
  const edition = params.get("edition");
  const messages = params.get("messages");
  const mau = params.get("mau");
  const message = form.querySelector("#message");
  if (message && (edition || messages) && !message.value) {
    message.value = [
      edition ? `Calculator edition: ${edition}` : "",
      messages ? `Messages / month: ${Number(messages).toLocaleString("en-US")}` : "",
      mau ? `MAU: ${Number(mau).toLocaleString("en-US")}` : "",
    ]
      .filter(Boolean)
      .join("\n");
  }

  const showNotice = (text, ok) => {
    notice.hidden = false;
    notice.textContent = text;
    notice.style.color = ok ? "" : "var(--rose)";
  };

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    const email = String(formData.get("email") || "");
    if (!email.includes("@")) {
      showNotice("Enter a valid work email so we can route this to Restora.", false);
      return;
    }

    formData.append("access_key", WEB3FORMS_KEY);
    formData.append("subject", "Essenize deployment conversation");
    formData.append("from_name", "Essenize website");

    const originalText = submitBtn ? submitBtn.textContent : "";
    if (submitBtn) {
      submitBtn.textContent = "Sending...";
      submitBtn.disabled = true;
    }

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (response.ok && data.success) {
        showNotice("Success. Your message has been sent to Restora.", true);
        form.reset();
      } else {
        showNotice(data.message || "The request could not be sent. Please try again.", false);
      }
    } catch (error) {
      showNotice("Something went wrong. Please try again.", false);
    } finally {
      if (submitBtn) {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
      }
    }
  });
}
